import React, { useEffect, useMemo, useCallback, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import L from 'leaflet';
import 'leaflet.sync';
import _ from 'underscore';
import { onUpdateLegend } from 'components/MapGeneric/actions/MapActionsGeneric';
import { makeStyles } from '@mui/styles';
import {
	Button, Chip, Collapse, Divider, Drawer,
	FormControlLabel, Radio, RadioGroup, Slider,
	TextField, Typography, Checkbox, Card, Grid, FormControl,
	FormGroup, FormLabel, Switch, ToggleButton, ToggleButtonGroup,
	Autocomplete, createFilterOptions
} from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { Page, Header, MapGeneric, SelectField, Label, SearchBar, FiltersDrawer } from 'components';
import validate from 'validate.js';
import {
	SetFormState, ToggleSummaryDialog, GetSiteIdLocation,
} from '../../actions/MapDriveTestsActionsGeneric';

const useStyles = makeStyles((theme) => ({
	root: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
	},
	drawer: {
		width: 420,
		maxWidth: '100%',
	},
	header: {
		padding: theme.spacing(2, 1),
		display: 'flex',
		justifyContent: 'space-between',
	},
	buttonIcon: {
		marginRight: theme.spacing(1),
	},
	content: {
		padding: theme.spacing(0, 3),
		flexGrow: 1,
	},
	contentSection: {
		padding: theme.spacing(2, 0),
	},
	contentSectionHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		cursor: 'pointer',
	},
	contentSectionContent: {},
	formGroup: {
		padding: theme.spacing(2, 0),
	},
	fieldGroup: {
		display: 'flex',
		alignItems: 'center',
	},
	field: {
		marginTop: 0,
		marginBottom: 0,
	},
	flexGrow: {
		flexGrow: 1,
	},
	addButton: {
		marginLeft: theme.spacing(1),
	},
	tags: {
		marginTop: theme.spacing(1),
	},
	minAmount: {
		marginRight: theme.spacing(3),
	},
	maxAmount: {
		marginLeft: theme.spacing(3),
	},
	radioGroup: {},
	actions: {
		padding: theme.spacing(3),
		'& > * + *': {
			marginTop: theme.spacing(2),
		},
	},
}));

const TopToolBarGeneric = (props) => {
	const { className, open, onClose, onFilter, filterDisabled, onClear, ...rest } = props;
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.mapDriveTestsReducer.formState);
	const sitesIds = useSelector(state => state.mapDriveTestsReducer.sitesIds);
	const maps = useSelector(state => state.mapReducer.maps);

	const handleChangeMapFilters = (event) => {
		if (event.target.checked) {
			setFormState({
				...formState,
				values: {
					...formState.values,
					[event.target.name]:
						event.target.type === 'checkbox'
							? event.target.checked
							: event.target.value,
					mapSize: 10
				},
			});
		} else {
			setFormState({
				...formState,
				values: {
					...formState.values,
					[event.target.name]:
						event.target.type === 'checkbox'
							? event.target.checked
							: event.target.value,
					mapSize: 12
				}
			});
		}
	};

	const handleChangeMapAutoZoom = (event) => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]:
					event.target.type === 'checkbox'
						? event.target.checked
						: event.target.value
			},
			touched: {
				...formState.touched,
				[event.target.name]: true,
			},
		});
	};

	const _onSiteIdChange = (value) => {
		let siteId = null;
		if (value !== null) {
			siteId = value.value;
		}
		dispatch(GetSiteIdLocation(siteId));
	};

	const _onSummaryClick = (event) => {
		dispatch(ToggleSummaryDialog(true));
	};

	const cardStyle = {
		// height: '10vh'
	};

	const filterOptions = createFilterOptions({
		limit: 20
	});

	return (
		<Card style={cardStyle}>
			<div className={classes.content}>
				<div className={classes.contentSection}>
					<Grid container spacing={1}>
						<Grid item md={8} xs={8}>
							<FormControlLabel
								name="mapAutoZoom"
								control={<Switch color="primary" />}
								label="Auto Zoom"
								labelPlacement="start"
								checked={formState.values.mapAutoZoom}
								onChange={handleChangeMapAutoZoom}
							/>
							<FormControlLabel
								name="mapFilters"
								control={<Switch color="primary" />}
								label="Filters"
								labelPlacement="start"
								checked={formState.values.mapFilters}
								onChange={handleChangeMapFilters}
							/>
						</Grid>
						{/*	<Grid item md={2} xs={2} align="right">
							<Autocomplete
								id="sitesIds"
								options={sitesIds}
								getOptionLabel={(option) => option.text}
								onChange={(event, value) => { _onSiteIdChange(value); }}
								renderInput={(params) => <TextField {...params} label="SiteId" variant="outlined" size="small" />}
								filterOptions={filterOptions}
							/>
							</Grid>
						<Grid item md={2} xs={2} align="right">
							<Button
								className={classes.agreeButton}
								color="primary"
								onClick={_onSummaryClick}
								variant="contained"
								size="small"
							>
								Summary
							</Button>
						</Grid> */}
					</Grid>
				</div>
			</div>
		</Card>
	);
};

TopToolBarGeneric.propTypes = {
	className: PropTypes.string,
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onFilter: PropTypes.func.isRequired,
	filterDisabled: PropTypes.bool,
	onClear: PropTypes.func
};

export default TopToolBarGeneric;
